import { render, staticRenderFns } from "./VehicleMetadata.vue?vue&type=template&id=1c325ada&scoped=true&"
import script from "./VehicleMetadata.vue?vue&type=script&lang=js&"
export * from "./VehicleMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c325ada",
  null
  
)

export default component.exports